import { FormSection } from '@@/form-components/FormSection';
import { TextTip } from '@@/Tip/TextTip';

export function HelmRepositoryForm() {
  return (
    <FormSection title="Helm Repository">
      <TextTip color="orange" className="mb-3">
        Helm Repository deployment method is not yet implemented. Please use Git
        Repository as the build method for Helm charts.
      </TextTip>
    </FormSection>
  );
}
